import { Component, OnDestroy } from '@angular/core';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Subject } from 'rxjs';
import { takeUntil, finalize } from 'rxjs/operators';

import { ChannelProductMappingApiService, SnackBarConfig } from '../../../shared';

@Component({
  selector: 'lum-channel-product-mapping-checkbox-cell-renderer-v2',
  templateUrl: './channel-product-mapping-checkbox-cell-renderer-v2.component.html',
  styleUrls: ['./channel-product-mapping-checkbox-cell-renderer-v2.component.scss'],
})
export class ChannelProductMappingCheckboxCellRendererV2Component
  implements ICellRendererAngularComp, OnDestroy
{
  params :ICellRendererParams;
  private onDestroy$ = new Subject();
  previousState :boolean = false;

  constructor(
    private channelProductMappingApiService :ChannelProductMappingApiService,
    private snackBar :MatSnackBar,
  ) {}

  agInit(params :ICellRendererParams) :void {
    this.params = params;
    this.previousState = params.data.ignoreStock;
  }

  ngOnDestroy() :void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }

  onChange(event :Event) :void {
    const input = event.target as HTMLInputElement;
    this.params.data.ignoreStock = input.checked;

    const payload = {
      channelId: this.params.data?.channelId,
      ignored: (input.checked || false).toString(),
    };

    this.channelProductMappingApiService
      .saveChannelProductOverride(this.params.data.id, payload)
      .pipe(
        takeUntil(this.onDestroy$),
        finalize(() => {
          this.params.api.stopEditing();
        }),
      )
      .subscribe({
        next: (response) => {
          this.snackBar.open('Successfully saved.', 'Success', {
            duration: SnackBarConfig.DEFAULT.duration,
          });
        },
        error: (error) => {
          this.snackBar.open('Failed to save changes.', 'Error', {
            duration: SnackBarConfig.DEFAULT.duration,
          });
        },
      });
  }

  refresh(params :ICellRendererParams) :boolean {
    return true;
  }
}
